// services/finance.service.js

const API_URL = "https://ims.holdthechild.net";

export const getToken = () => localStorage.getItem("token");

const getRequest = async (endpoint, params = {}) => {
  try {
    const token = getToken();
    const query = new URLSearchParams(params).toString();
    const url = `${API_URL}${endpoint}${query ? `?${query}&_t=${Date.now()}` : `?_t=${Date.now()}`}`;
    const response = await fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    if (!response.ok) {
      const errorBody = await response.json().catch(() => ({ message: "Server error" }));
      throw new Error(errorBody.message || "Request failed");
    }
    return await response.json();
  } catch (error) {
    console.error(`GET ${endpoint} error:`, error.message);
    throw error;
  }
};

/* ================= Finance Services ================= */

/**
 * Get Overview Dashboard Stats
 */
export const fetchFinanceDashboard = async () => {
  const res = await getRequest("/api/finance/dashboard");
  return res.data; 
};

/**
 * Get Universal Transaction Ledger
 */
export const fetchFinanceTransactions = async (params = {}) => {
  const res = await getRequest("/api/finance/transactions", params);
  return res; 
};

/**
 * Get Payroll Analytics (Trends)
 */
export const fetchPayrollAnalytics = async () => {
  const res = await getRequest("/api/finance/analytics/payroll");
  return res.data; 
};

/**
 * Get Specific Project Financials (For detailed view)
 */
export const fetchProjectFinancials = async (projectId) => {
  const res = await getRequest(`/api/finance/projects/${projectId}`);
  return res.data;
};

/**
 * Get List of Projects for the Sieve Dropdown
 */
export const fetchProjectsList = async () => {
  const res = await getRequest("/api/projects"); // Assuming you have a generic projects endpoint
  // Adjusting for the specific response structure used in your Project Controller
  const projects = Array.isArray(res) ? res : (res.data || []);
  return projects;
};

// NEW: Fetch Financial Overview (Budget Code Balancing Logic)
export const fetchFinancialOverview = async () => {
  try {
    const response = await fetch("/api/finance/overview", {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });
    const data = await response.json();
    if (!response.ok) throw new Error(data.message || "Failed to fetch overview");
    return data.data; // Returns { summary, bankBalances }
  } catch (error) {
    console.error("API Error:", error);
    throw error;
  }
};
